/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LearnArtifactCreate
 */
export interface LearnArtifactCreate {
    /**
     * 
     */
    kind: string;
    /**
     * 
     */
    title: string;
    /**
     * Arbitrary JSON owned by the frontend. The backend persists and returns it verbatim and
     * never inspects, validates, or migrates it.
     * 
     */
    payload: { [key: string]: any; };
    /**
     * 
     */
    activityKey?: string | null;
}

/**
 * Check if a given object implements the LearnArtifactCreate interface.
 */
export function instanceOfLearnArtifactCreate(value: object): value is LearnArtifactCreate {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('payload' in value) || value['payload'] === undefined) return false;
    return true;
}

export function LearnArtifactCreateFromJSON(json: any): LearnArtifactCreate {
    return LearnArtifactCreateFromJSONTyped(json, false);
}

export function LearnArtifactCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearnArtifactCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'title': json['title'],
        'payload': json['payload'],
        'activityKey': json['activity_key'] === undefined ? undefined : json['activity_key'] === null ? null : json['activity_key'],
    };
}

export function LearnArtifactCreateToJSON(json: any): LearnArtifactCreate {
    return LearnArtifactCreateToJSONTyped(json, false);
}

export function LearnArtifactCreateToJSONTyped(value?: LearnArtifactCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'title': value['title'],
        'payload': value['payload'],
        'activity_key': value['activityKey'],
    };
}

